

import './index.css';

function WeeklyUpdates({ handle, meta, domain, parentId, updateDomain }) {
  const emptyWeekly = () => {
    return { weekStart: '', summary: '', health: 'green', blockers: '', nextSteps: '' };
  };

  const addListItem = (key, emptyValueFactory) => {
    updateDomain((prev) => ({
      ...prev,
      [key]: [...(prev[key] || []), emptyValueFactory()],
    }));
  };

  const updateListItem = (key, index, field, value) => {
    updateDomain((prev) => {
      const nextItems = [...(prev[key] || [])];
      nextItems[index] = {
        ...(nextItems[index] || {}),
        [field]: value,
      };
      return { ...prev, [key]: nextItems };
    });
  };

  const removeListItem = (key, index) => {
    updateDomain((prev) => {
      const nextItems = [...(prev[key] || [])];
      nextItems.splice(index, 1);
      return { ...prev, [key]: nextItems };
    });
  };

  return (
    <section className="card-subsection">
      <div className="row-between">
        <h3 className="section-title">Weekly Updates</h3>
        <button className="button-secondary" type="button" onClick={() => addListItem('weeklyUpdates', emptyWeekly)}>
          Add Update
        </button>
      </div>
      <div className="stack-sm">
        {domain.weeklyUpdates?.map((item, index) => (
          <div className="inline-form-card wrap" key={item.id || `weekly-${index}`}>
            <input
              type="date"
              value={item.weekStart}
              onChange={(e) => updateListItem('weeklyUpdates', index, 'weekStart', e.target.value)}
            />
            <select value={item.health} onChange={(e) => updateListItem('weeklyUpdates', index, 'health', e.target.value)}>
              <option value="green">Green</option>
              <option value="yellow">Yellow</option>
              <option value="red">Red</option>
            </select>
            <input
              placeholder="Summary"
              value={item.summary}
              onChange={(e) => updateListItem('weeklyUpdates', index, 'summary', e.target.value)}
            />
            <input
              placeholder="Blockers"
              value={item.blockers}
              onChange={(e) => updateListItem('weeklyUpdates', index, 'blockers', e.target.value)}
            />
            <input
              placeholder="Next Steps"
              value={item.nextSteps}
              onChange={(e) => updateListItem('weeklyUpdates', index, 'nextSteps', e.target.value)}
            />
            <button className="button-danger" type="button" onClick={() => removeListItem('weeklyUpdates', index, emptyWeekly)}>
              Remove
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}

export default WeeklyUpdates;